const Constants = {
  headingText: "Liquefaction",
  baseMapUrl:
    "https://services1.arcgisonline.co.nz/arcgis/rest/services/Imagery/newzealand/MapServer",
  propertySearchLayer:
    "https://gis.tauranga.govt.nz/server/rest/services/RM_PropertySearch/FeatureServer/1",

  aerialTileLayer:
    "https://gis.tauranga.govt.nz/server/rest/services/CommonMapServices/Aerial_Foreground/MapServer",

  propertyTileLayer:
    "https://gisapps.tauranga.govt.nz/arcgis/rest/services/Basemaps/AerialForeground/MapServer",

  contourTilesLayer:
    "https://gis.tauranga.govt.nz/server/rest/services/GPSIT_Contour_1m_2022_NZVD16/MapServer",

  earthquakeLayerUrl:
    "https://gis.tauranga.govt.nz/server/rest/services/Liquefaction/MapServer",

  introductionText:
    "This tool allows you to view liquefaction vulnerability and liquefaction induced land damage caused by different sized earthquake events.",

  step1Text: "Select 'vulnerability' or 'land damage'",
  step2Text: "Select Land Damage scenario",
  step3Text: "Select Earthquake Event",

  slr1Title: "Current",
  slr1Text:
    "This group of data presents the extent of land damage under a range of earthquake shaking events using a present day ground water table.",
  slr2Title: "Future",
  slr2Text:
    "This group of data presents the extent of land damage under a range of earthquake shaking events taking into account future ground water table levels.  This is as a result of projected increases in sea level of 1.05m NZVD 16.  This represents the projected sea level rise scenario for the year 2130.",

  slr3Title: "Year 2130",
  slr3Text:
    "This group of data presents the extent of land damage considering projected future ground water levels as a result of sea level rise of 1.25m. This represents a time horizon of around 2130.",

  slr4Title: "Land Damage",
  slr4Text:
    "Represents the liquefaction induced ground damage in an earthquake event. Damage can be vertical settlement, sand boils, horizontal movement or a combination of all of these. Different earthquake events and current or future timeline can be selected ",

  notesTitle: "Note:",
  notesText:
    "Different properties are exposed to different levels of probability that the hazard will in fact occur, and the sea level rise scenario assessed has its own uncertainty. The reports and modelling results are undertaken at a local scale and may be superseded by site specific, detailed assessments undertaken by qualified and experienced practitioners using improved or higher resolution data than presented in this study. The maps are prepared based on an assessment of natural ground conditions and therefore do not consider the influence of recent human activities such as earthworks. As such, the degree of land damage may be less than predicted for a given property where liquefaction risk was addressed during landform or building foundation design.",

  uncertaintyTitle: "Description of uncertainties:",
  uncertaintyText:
    "This assessment has been made at a broad scale across the entire city and is intended to approximately describe the typical range of liquefaction across neighbourhood-sized areas. It is not intended to precisely describe liquefaction at individual property scale. This information is general in nature, and more detailed site-specific liquefaction assessment will be required for some purposes (e.g. for design of building foundations).",

  legendTitle: "Land Damage Legend",
  legendData: [
    {
      color: "#00acf0",
      label: "None to Minor",
    },
    {
      color: "#9cbb5a",
      label: "Minor to Moderate",
    },
    {
      color: "#ee1924",
      label: "Moderate to Severe",
    },
  ],
  legendTitle2: "Liquefaction Vulnerability ",
  legendText2:
    "Assigning vulnerability categories is heavily dependant on the level of detail of the assessment. More testing provides more certainty. This city assessment was carried out predominantly at Level B - Calibrated desktop assessment",
  legendData2: [
    {
      color: "#bfbfbf",
      label: "Liquefaction Category is Undetermined",
    },
    {
      color: "#a1dab5",
      label: "Liquefaction Category is Unlikely",
    },
    {
      color: "#fed98d",
      label: "Liquefaction Category is Possible",
    },
    {
      color: "#1f5fa5",
      label: "Very Low Liquefaction Vulnerability",
    },
    {
      color: "#42b6c4",
      label: "Low Liquefaction Vulnerability",
    },
    {
      color: "#fe9a24",
      label: "Medium Liquefaction Vulnerability",
    },
    {
      color: "#cd4d00",
      label: "High Liquefaction Vulnerability",
    },
  ],
  slrTitle: "Time",
  stormSurgeTitle: "Earthquake Event",
  contourLayerWidgetTitle: "Contour layer",
  footnote: "* Incorporates changes to groundwater levels",
  vulnerabilityText:
    "This represents the potential for liquefaction damage to an area when an earthquake strikes based on physical parameters such as soil type, particle size, density and depth to ground water.",
  mapLabelLiquefactionVulnerability: "Potential Liquefaction Vulnerability",
  variabilityTitle: "Variability",
  variabilityText:
    "There is considerable uncertainty involved in estimating liquefaction-induced ground damage. These categories are intended to provide a general indication of the damage that might typically be expected. However there can be wide variation in land performance, even where ground conditions appear to be similar, with damage in some cases being much greater or less than inferred from the damage category.",
  returnPeriodTitle: "Return Period",
  returnPeriodText: `A return period, also known as a recurrence interval or probability, is an estimated average time between natural events such as earthquakes or floods. For example an event might have a return period of 100 years - this is expressed as a probability, being 1 in 100 years, 1/100, or 1%. It means that in any year there is a 1% chance the event will happen, regardless of when the last event occurred`,
  liquefactionTitle: "Liquefaction Vulnerability",
  liquefactionText:
    "Represents the potential for liquefaction damage to an area when an earthquake strikes based on physical parameters such as soil type, particle size, density and depth to ground water.",
  liquefactionNoteTitle: "Note",
  liquefactionNoteText:
    "Different properties are exposed to different levels of probability that the hazard will in fact occur, and the sea level rise scenario assessed has its own uncertainty. The reports and modelling results are undertaken at a local scale and may be superseded by site specific, detailed assessments undertaken by qualified and experienced practitioners using improved or higher resolution data than presented in this study. The maps are prepared based on an assessment of natural ground conditions and therefore do not consider the influence of recent human activities such as earthworks. As such, the degree of land damage may be less than predicted for a given property where liquefaction risk was addressed during landform or building foundation design.",
};

const year0 = "Vulnerability";
const year1 = "Land Damage";

const slr0 = "Current";
const slr1 = "Future*";

const liquidfactionLevel0 = "1 in 25 year";
const liquidfactionLevel1 = "1 in 100 year";
const liquidfactionLevel2 = "1 in 250 year";
const liquidfactionLevel3 = "1 in 500 year";
const liquidfactionLevel4 = "1 in 1000 year";

export const contourTilesLayerTitle = "contours";
export const earthquakeTileLayerTitle = "Earthquake liquefaction";

export const dataObject = [
  {
    label: year0,
  },
  {
    label: year1,
    seaLevels: [
      {
        label: slr0,
        stormEvents: [
          {
            label: liquidfactionLevel0,
            layer: 1,
          },
          {
            label: liquidfactionLevel1,
            layer: 2,
          },
          {
            label: liquidfactionLevel2,
            layer: 3,
          },
          {
            label: liquidfactionLevel3,
            layer: 4,
          },
          {
            label: liquidfactionLevel4,
            layer: 5,
          },
        ],
      },
      {
        label: slr1,
        stormEvents: [
          {
            label: liquidfactionLevel0,
            layer: 6,
          },
          {
            label: liquidfactionLevel1,
            layer: 7,
          },
          {
            label: liquidfactionLevel2,
            layer: 8,
          },
          {
            label: liquidfactionLevel3,
            layer: 9,
          },
          {
            label: liquidfactionLevel4,
            layer: 10,
          },
        ],
      },
    ],
  },
];

export default Constants;
